import {
    Box,
    CircularLoading,
    Grid,
    ToggleButton,
    ToggleButtonGroup,
} from "@biggeo/bg-ui/lab";
import {
    AddOutline,
    AddPhotoAlternateOutline,
    PublicOutline,
    RemoveOutline,
    TwoDOutline,
} from "@biggeo/bg-ui/lab/icons";
import { useErrorToast } from "../../../toaster/containers/redux/hooks";
import { useScreenshot } from "../hooks/other-hooks";

interface IMapControls {
    zoomIn: () => void;
    zoomOut: () => void;
    projection: "mercator" | "globe";
    changeProjection: (proj: "mercator" | "globe") => void;
    channelId: string;
}

const MapControls = ({
    zoomIn,
    zoomOut,
    projection,
    changeProjection,
}: IMapControls) => {
    const errorToast = useErrorToast();
    const { getScreenshot, loading } = useScreenshot();

    const getMapScreenshot = async () => {
        await getScreenshot({
            elementId: "map",
            onError: (message) => errorToast(message),
        });
    };

    return (
        <Box
            sx={{
                position: "absolute",
                right: 4,
                top: 5,
            }}
        >
            <Grid
                container
                gap={2}
                flexDirection={"column"}
                alignItems="center"
            >
                <Grid item>
                    <ToggleButtonGroup
                        sx={{
                            flexDirection: "column",
                            background: (theme) =>
                                theme.palette.background.main,
                        }}
                    >
                        <ToggleButton onClick={zoomIn}>
                            <AddOutline />
                        </ToggleButton>
                        <ToggleButton onClick={zoomOut}>
                            <RemoveOutline />
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
                <Grid item>
                    <ToggleButtonGroup
                        value={projection}
                        sx={{
                            flexDirection: "column",
                            background: (theme) =>
                                theme.palette.background.main,
                        }}
                    >
                        <ToggleButton
                            value="mercator"
                            onClick={() => {
                                changeProjection("mercator");
                            }}
                        >
                            <TwoDOutline />
                        </ToggleButton>
                        <ToggleButton
                            value="globe"
                            onClick={() => {
                                changeProjection("globe");
                            }}
                        >
                            <PublicOutline />
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
                <Grid item>
                    <ToggleButtonGroup
                        sx={{
                            background: (theme) =>
                                theme.palette.background.main,
                        }}
                    >
                        <ToggleButton onClick={getMapScreenshot}>
                            {loading ? (
                                <CircularLoading size="xs" color="surface" />
                            ) : (
                                <AddPhotoAlternateOutline size="xs" />
                            )}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Grid>
            </Grid>
        </Box>
    );
};

export default MapControls;
